import axios from 'axios'
import { URL, SUBSCRIPTION } from '../../static/config.json'

let headers = {
    'Content-Type': 'application/json',
}
if (localStorage.token) {
    headers['X-Auth-Token'] = localStorage.token
}

if (SUBSCRIPTION !== '') {
    headers['Ocp-Apim-Subscription-Key'] = SUBSCRIPTION
}

export const setToken = (token) => {
    headers['X-Auth-Token'] = token;
}

export const hapiickApi = () => {
    return axios.create({
        baseURL: URL,
        headers
    })
}



// WEBPACK FOOTER //
// ./src/api/hapiickApi.js